import styled from 'styled-components';
import { animated } from 'react-spring';
import { breakpoints } from '../../constants';

export const DesktopOnly = styled(animated.div)`
    display: none;

    @media (${breakpoints.mediumMin}) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
`;
